import type { Editor } from "@tiptap/react";
import { useAddTipTapLinkModal } from "@circle-react-uikit/TipTapBlockEditor/AddTipTapLinkModal";
import { MenuBarItem } from "./MenuBarItem";

export interface MenuBarProps {
  editor: Editor | null;
}

export const MenuBar = ({ editor }: MenuBarProps) => {
  const tiptapLinkModal = useAddTipTapLinkModal();

  const handleLinkClick = () => {
    if (!editor) {
      return;
    }

    void tiptapLinkModal.show({ editor });
  };

  return (
    <div className="-mx-3 mb-2 flex items-center gap-0.5 border-b p-1.5">
      <MenuBarItem
        isActive={editor?.isActive("bold")}
        icon="16-bold"
        onClick={() => editor?.chain().focus().toggleBold().run()}
      />
      <MenuBarItem
        isActive={editor?.isActive("italic")}
        onClick={() => editor?.chain().focus().toggleItalic().run()}
        icon="16-italic"
      />
      <MenuBarItem
        isActive={editor?.isActive("underline")}
        onClick={() => editor?.chain().focus().toggleUnderline().run()}
        icon="16-edit-underline"
      />
      <MenuBarItem
        isActive={editor?.isActive("link")}
        icon="16-link-alt"
        onClick={handleLinkClick}
      />
    </div>
  );
};
